// --------------------------------------------------------
// CARE LINE ADD AREA - CareLineAddArea
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useEffect, useState } from "react";
import Colors from "../../constants/Colors";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import CareLineDropdown from "../dropdown/CareLineDropdown";
import { ResponsiveContainer, Text } from "../UI/generalLayout/Layout.styled";
import { ReactComponent as TrashBin } from "../../assets/imgs/trashBin.svg";
import { RemoveButton } from "./CareLineAddArea.styled";
import Autocomplete from "@mui/material/Autocomplete";
import { ExamService } from "../../core/http/service/ExamService";
import { TextField } from "@mui/material";
import { log } from "console";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CARE LINE ADD AREA INTERFACE
// --------------------------------------------------------

interface ICareLineAddArea {
  dropdownPlaceholder: string;
  mainDropdownTopText: string;
  mainValue: any;
  error?: boolean;
  onChangeMainValue: any;
  mainValueItems: any[];
  intervalo?: any;
  onChangeIntervalo?: any;
  intervaloItems?: any[];
  formato?: any;
  onChangeFormato?: any;
  formatoItems?: any[];
  disabled?: boolean;
  showRemoveButton?: boolean;
  onRemove?: any;
}
/**
/**
 * A component that renders a Care line add area.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CareLineAddArea = ({
  dropdownPlaceholder,
  mainDropdownTopText,
  mainValue,
  onChangeMainValue,
  mainValueItems,
  error = false,
  intervalo = null,
  onChangeIntervalo = () => {},
  intervaloItems = [],
  formato = null,
  onChangeFormato = () => {},
  formatoItems = [],
  disabled = false,
  showRemoveButton = false,
  onRemove = () => {},
}: ICareLineAddArea) => {
  // --------------------------------------------------------
  // CARE LINE ADD AREA PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();
  const [isObjectWithEmptyValue, setIsObjectWithEmptyValue] = useState(false);

  useEffect(() => {
    const hasEmptyInterval =
      intervalo !== null
        ? Object.keys(mainValue.intervaloMeses).length === 0
        : false;
    const hasEmptyFormato =
      formato !== null ? Object.keys(mainValue.formato).length === 0 : false;
    const hasEmptyMainValue = mainValue.id === "";

    if (hasEmptyInterval || hasEmptyFormato || hasEmptyMainValue) {
      setIsObjectWithEmptyValue(true);
    } else {
      setIsObjectWithEmptyValue(false);
    }
  }, [mainValue]);

  // --------------------------------------------------------

  const [examsOption, setExamsOptions] = useState<any[]>([]);
  const [exams, setExams] = useState<any[]>([]);

  const fetchExams = async (event: any, newValue: any | null) => {
    const examService: ExamService = new ExamService();
    const examResponse: any = await examService.getAll(newValue);

    setExamsOptions(examResponse.data.data);
  };

  const insertElementIntoAdditionalExam = (object: any) => {
    setExams((prev: any) => {
      const list = [...prev];
      const removedElement = list.splice(object.id, 1);
      const newObject = { ...removedElement[0], ...object };
      list.splice(object.id, 0, newObject);
      return list;
    });
  };

  useEffect(() => {
    if (examsOption.length === 1) {
      onChangeMainValue(...examsOption);
    }
  }, [examsOption]);

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <ResponsiveContainer isMobile={isMobile}>
        <div style={{ marginRight: 16 }}>
          <Text style={{ color: Colors.GRAY400 }}>{mainDropdownTopText}</Text>
          {mainDropdownTopText === "Selecione os exames" ? (
            <Autocomplete
              value={mainValue}
              autoComplete
              includeInputInList
              filterSelectedOptions
              disabled={disabled}
              filterOptions={(x) => x}
              getOptionLabel={(option) => (option.nome ? option.nome : "")}
              noOptionsText="Nenhum exame encontrado"
              onInputChange={(event, newInputValue) => {
                if (newInputValue.length >= 3) {
                  fetchExams(event, newInputValue);
                } else {
                  setExamsOptions([]);
                }
              }}
              onChange={(event, newValue) => {
                onChangeMainValue(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size={"small"}
                  style={{ backgroundColor: "white" }}
                  label="Selecione o exame"
                />
              )}
              options={examsOption}
              sx={{
                width: 400,

                "& input": {
                  height: 40,
                },
              }}
            />
          ) : (
            <CareLineDropdown
              error={error && isObjectWithEmptyValue}
              value={mainValue}
              placeholder={dropdownPlaceholder}
              containerStyle={{ width: isMobile ? "100%" : "" }}
              style={{ width: isMobile ? "100%" : 310 }}
              onChange={(value: any) => {
                onChangeMainValue(value);
              }}
              items={mainValueItems}
              disabled={disabled}
            />
          )}
        </div>

        {intervalo !== null && (
          <div style={{ marginRight: 16 }}>
            <Text style={{ color: Colors.GRAY400 }}>Intervalo</Text>
            <CareLineDropdown
              error={error && isObjectWithEmptyValue}
              value={intervalo}
              placeholder="Intervalo"
              containerStyle={{ width: isMobile ? "100%" : "" }}
              style={{ width: isMobile ? "100%" : 200 }}
              onChange={(value: any) => {
                onChangeIntervalo(value);
              }}
              items={intervaloItems}
              disabled={disabled}
            />
          </div>
        )}

        {formato !== null && (
          <div style={{ marginRight: 16 }}>
            <Text style={{ color: Colors.GRAY400 }}>Formato</Text>
            <CareLineDropdown
              error={error && isObjectWithEmptyValue}
              value={formato}
              placeholder="Formato"
              containerStyle={{ width: isMobile ? "100%" : "" }}
              style={{ width: isMobile ? "100%" : 200 }}
              onChange={(value: any) => {
                onChangeFormato(value);
              }}
              items={formatoItems}
              disabled={disabled}
            />
          </div>
        )}
        {/** Fazer um styled com essa div para ter um onClick, cursor e hover. Colocar uma flag para quando mostrar o botão  */}
        {showRemoveButton && (
          <RemoveButton
            onClick={disabled ? () => {} : onRemove}
            isMobile={isMobile}
            disabled={disabled}
          >
            <TrashBin />
          </RemoveButton>
        )}
      </ResponsiveContainer>
    </>
  );
  // --------------------------------------------------------
};

export default CareLineAddArea;
